/* eslint-disable */
require('./2horpanel')
require('./2vertpanel')
require('./3panel')
require('./4panel')
require('./about')
require('./arrow')
require('./changeBckgd')
require('./check')
require('./close')
require('./closeFullScreen')
require('./contact')
require('./dock')
require('./fullScreen')
require('./hamburger')
require('./help')
require('./magnifyingGlass')
require('./pause')
require('./permalink')
require('./play')
require('./resetZoom')
require('./singlepanel')
require('./social')
require('./tooltips')
require('./undock')
require('./zoomIn')
require('./zoomOut')
